export const allEmj =
    "[右哼哼] [奸笑] [红包] [生病] [冷汗] [惊恐] [Emm] [得意] [菜刀] [太阳] [捂脸] [机智] [耶] [尴尬] [抓狂] [流汗] [社会社会] [擦汗] [西瓜] [拥抱] [破涕为笑] [皱眉] [鸡] [微笑] [发怒] [吐] [憨笑] [旺柴] [抠鼻] [啤酒] [强] [笑脸] [调皮] [呲牙] [惊讶] [难过] [色] [悠闲] [疑问] [鼓掌] [害羞] [睡] [无语] [偷笑] [愉快] [白眼] [傲慢] [困] [发呆] [好的] [坏笑] [咖啡] [弱] [失望] [奋斗] [咒骂] [吃瓜] [加油] [汗] [天啊] [打脸] [左哼哼] [饭] [握手] [调皮] [哇] [嘘] [晕] [衰] [骷髅] [敲打] [再见] [嘿哈] [猪头] [胜利] [恐惧] [哈欠] [鄙视] [委屈] [流泪] [快哭了] [阴险] [亲亲] [可怜] [玫瑰] [抱拳] [脸红] [凋谢] [嘴唇] [爱心] [心碎] [蛋糕] [闭嘴] [炸弹] [便便] [月亮] [勾引] [合十] [拳头] [OK] [大哭] [跳跳] [发抖] [怄火] [转圈] [礼物] [庆祝]";
export const emjNameList = ["[右哼哼]", "[奸笑]", "[红包]", "[生病]", "[冷汗]", "[惊恐]", "[Emm]", "[得意]", "[菜刀]", "[太阳]", "[捂脸]", "[机智]", "[耶]", "[尴尬]", "[抓狂]", "[流汗]", "[社会社会]", "[擦汗]", "[西瓜]", "[拥抱]", "[破涕为笑]", "[皱眉]", "[鸡]", "[微笑]", "[发怒]", "[吐]", "[憨笑]", "[旺柴]", "[抠鼻]", "[啤酒]", "[强]", "[笑脸]", "[调皮]", "[呲牙]", "[惊讶]", "[难过]", "[色]", "[悠闲]", "[疑问]", "[鼓掌]", "[害羞]", "[睡]", "[无语]", "[偷笑]", "[愉快]", "[白眼]", "[傲慢]", "[困]", "[发呆]", "[好的]", "[坏笑]", "[咖啡]", "[弱]", "[失望]", "[奋斗]", "[咒骂]", "[吃瓜]", "[加油]", "[汗]", "[天啊]", "[打脸]", "[左哼哼]", "[饭]", "[握手]", "[调皮]", "[哇]", "[嘘]", "[晕]", "[衰]", "[骷髅]", "[敲打]", "[再见]", "[嘿哈]", "[猪头]", "[胜利]", "[恐惧]", "[哈欠]", "[鄙视]", "[委屈]", "[流泪]", "[快哭了]", "[阴险]", "[亲亲]", "[可怜]", "[玫瑰]", "[抱拳]", "[脸红]", "[凋谢]", "[嘴唇]", "[爱心]", "[心碎]", "[蛋糕]", "[闭嘴]", "[炸弹]", "[便便]", "[月亮]", "[勾引]", "[合十]", "[拳头]", "[OK]", "[大哭]", "[跳跳]", "[发抖]", "[怄火]", "[转圈]", "[礼物]", "[庆祝]"]

export const emojMap = { 
    "[右哼哼]": "/v2/api/wxproxyv1/images/1.png", 
    "[奸笑]": "/v2/api/wxproxyv1/images/2.png", 
    "[红包]": "/v2/api/wxproxyv1/images/3.png", 
    "[生病]": "/v2/api/wxproxyv1/images/4.png", 
    "[冷汗]": "/v2/api/wxproxyv1/images/5.png", 
    "[惊恐]": "/v2/api/wxproxyv1/images/6.png", 
    "[Emm]": "/v2/api/wxproxyv1/images/7.png", 
    "[得意]": "/v2/api/wxproxyv1/images/8.png", 
    "[菜刀]": "/v2/api/wxproxyv1/images/9.png", 
    "[太阳]": "/v2/api/wxproxyv1/images/10.png", 
    "[捂脸]": "/v2/api/wxproxyv1/images/11.png", 
    "[机智]": "/v2/api/wxproxyv1/images/12.png", 
    "[耶]": "/v2/api/wxproxyv1/images/13.png", 
    "[尴尬]": "/v2/api/wxproxyv1/images/14.png", 
    "[抓狂]": "/v2/api/wxproxyv1/images/15.png", 
    "[流汗]": "/v2/api/wxproxyv1/images/16.png", 
    "[社会社会]": "/v2/api/wxproxyv1/images/17.png", 
    "[擦汗]": "/v2/api/wxproxyv1/images/18.png", 
    "[西瓜]": "/v2/api/wxproxyv1/images/19.png", 
    "[拥抱]": "/v2/api/wxproxyv1/images/20.png", 
    "[破涕为笑]": "/v2/api/wxproxyv1/images/21.png",
    "[皱眉]": "/v2/api/wxproxyv1/images/22.png", 
    "[鸡]": "/v2/api/wxproxyv1/images/23.png", 
    "[微笑]": "/v2/api/wxproxyv1/images/24.png", 
    "[发怒]": "/v2/api/wxproxyv1/images/25.png", 
    "[吐]": "/v2/api/wxproxyv1/images/26.png", 
    "[憨笑]": "/v2/api/wxproxyv1/images/27.png", 
    "[旺柴]": "/v2/api/wxproxyv1/images/28.png", 
    "[抠鼻]": "/v2/api/wxproxyv1/images/29.png", 
    "[啤酒]": "/v2/api/wxproxyv1/images/30.png", 
    "[强]": "/v2/api/wxproxyv1/images/31.png", 
    "[笑脸]": "/v2/api/wxproxyv1/images/32.png", 
    "[调皮]": "/v2/api/wxproxyv1/images/65.png", 
    "[呲牙]": "/v2/api/wxproxyv1/images/34.png", 
    "[惊讶]": "/v2/api/wxproxyv1/images/35.png", 
    "[难过]": "/v2/api/wxproxyv1/images/36.png", 
    "[色]": "/v2/api/wxproxyv1/images/37.png", 
    "[悠闲]": "/v2/api/wxproxyv1/images/38.png", 
    "[疑问]": "/v2/api/wxproxyv1/images/39.png", 
    "[鼓掌]": "/v2/api/wxproxyv1/images/40.png", 
    "[害羞]": "/v2/api/wxproxyv1/images/41.png", 
    "[睡]": "/v2/api/wxproxyv1/images/42.png", 
    "[无语]": "/v2/api/wxproxyv1/images/43.png", 
    "[偷笑]": "/v2/api/wxproxyv1/images/44.png", 
    "[愉快]": "/v2/api/wxproxyv1/images/45.png", 
    "[白眼]": "/v2/api/wxproxyv1/images/46.png", 
    "[傲慢]": "/v2/api/wxproxyv1/images/47.png", 
    "[困]": "/v2/api/wxproxyv1/images/48.png", 
    "[发呆]": "/v2/api/wxproxyv1/images/49.png", 
    "[好的]": "/v2/api/wxproxyv1/images/50.png", 
    "[坏笑]": "/v2/api/wxproxyv1/images/51.png", 
    "[咖啡]": "/v2/api/wxproxyv1/images/52.png", 
    "[弱]": "/v2/api/wxproxyv1/images/53.png", 
    "[失望]": "/v2/api/wxproxyv1/images/54.png", 
    "[奋斗]": "/v2/api/wxproxyv1/images/55.png", 
    "[咒骂]": "/v2/api/wxproxyv1/images/56.png", 
    "[吃瓜]": "/v2/api/wxproxyv1/images/57.png", 
    "[加油]": "/v2/api/wxproxyv1/images/58.png", 
    "[汗]": "/v2/api/wxproxyv1/images/59.png", 
    "[天啊]": "/v2/api/wxproxyv1/images/60.png", 
    "[打脸]": "/v2/api/wxproxyv1/images/61.png", 
    "[左哼哼]": "/v2/api/wxproxyv1/images/62.png", 
    "[饭]": "/v2/api/wxproxyv1/images/63.png", 
    "[握手]": "/v2/api/wxproxyv1/images/64.png", 
    "[哇]": "/v2/api/wxproxyv1/images/66.png", 
    "[嘘]": "/v2/api/wxproxyv1/images/67.png", 
    "[晕]": "/v2/api/wxproxyv1/images/68.png", 
    "[衰]": "/v2/api/wxproxyv1/images/69.png", 
    "[骷髅]": "/v2/api/wxproxyv1/images/70.png", 
    "[敲打]": "/v2/api/wxproxyv1/images/71.png", 
    "[再见]": "/v2/api/wxproxyv1/images/72.png", 
    "[嘿哈]": "/v2/api/wxproxyv1/images/73.png", 
    "[猪头]": "/v2/api/wxproxyv1/images/74.png", 
    "[胜利]": "/v2/api/wxproxyv1/images/75.png", 
    "[恐惧]": "/v2/api/wxproxyv1/images/76.png", 
    "[哈欠]": "/v2/api/wxproxyv1/images/77.png", 
    "[鄙视]": "/v2/api/wxproxyv1/images/78.png", 
    "[委屈]": "/v2/api/wxproxyv1/images/79.png", 
    "[流泪]": "/v2/api/wxproxyv1/images/80.png", 
    "[快哭了]": "/v2/api/wxproxyv1/images/81.png", 
    "[阴险]": "/v2/api/wxproxyv1/images/82.png", 
    "[亲亲]": "/v2/api/wxproxyv1/images/83.png", 
    "[可怜]": "/v2/api/wxproxyv1/images/84.png", 
    "[玫瑰]": "/v2/api/wxproxyv1/images/85.png", 
    "[抱拳]": "/v2/api/wxproxyv1/images/86.png", 
    "[脸红]": "/v2/api/wxproxyv1/images/87.png", 
    "[凋谢]": "/v2/api/wxproxyv1/images/88.png", 
    "[嘴唇]": "/v2/api/wxproxyv1/images/89.png", 
    "[爱心]": "/v2/api/wxproxyv1/images/90.png", 
    "[心碎]": "/v2/api/wxproxyv1/images/91.png", 
    "[蛋糕]": "/v2/api/wxproxyv1/images/92.png", 
    "[闭嘴]": "/v2/api/wxproxyv1/images/93.png", 
    "[炸弹]": "/v2/api/wxproxyv1/images/94.png", 
    "[便便]": "/v2/api/wxproxyv1/images/95.png", 
    "[月亮]": "/v2/api/wxproxyv1/images/96.png", 
    "[勾引]": "/v2/api/wxproxyv1/images/97.png", 
    "[合十]": "/v2/api/wxproxyv1/images/98.png", 
    "[拳头]": "/v2/api/wxproxyv1/images/99.png", 
    "[OK]": "/v2/api/wxproxyv1/images/100.png", 
    "[大哭]": "/v2/api/wxproxyv1/images/101.png", 
    "[跳跳]": "/v2/api/wxproxyv1/images/102.png", 
    "[发抖]": "/v2/api/wxproxyv1/images/103.png", 
    "[怄火]": "/v2/api/wxproxyv1/images/104.png", 
    "[转圈]": "/v2/api/wxproxyv1/images/105.png", 
    "[礼物]": "/v2/api/wxproxyv1/images/106.png", 
    "[庆祝]": "/v2/api/wxproxyv1/images/107.png" 
}